import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import Masonry from 'react-masonry-css';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout/index';
import HeroBanner from '../../components/HeroBanner';
import CTABanner from '../../components/CTABanner';
import MegaCarousel from '../../components/MegaCarousel';
import InfoCard from '../../components/InfoCard';
import AchievementCard from '../../components/AchievementCard';

import './style.scss';

import performanceHighlights from './content/performanceHighlights.json';
import achievementCards from './content/achievements.json';

const HomePage = () => {
  return (
    <Layout pageTitle="Home">
      <HeroBanner
        title="Welcome to Highlights from the Councils’ 2020/21 Annual Report"
        photo={
          <StaticImage
            className="shape shape-photo"
            width={738}
            quality={100}
            layout="fixed"
            src="./assets/hero-photo.png"
            alt="John Vines OAM Professional Standards Councils Chair"
          />
        }
      >
        <p>
          “I am pleased to introduce this Annual Report on behalf of the Professional Standards Councils, outlining our
          work and achievements in 2020/21 and the outlook for 2021/22.”
        </p>

        <p className="quote-author">
          John Vines OAM
          <br />
          Chair
          <br />
          Professional Standards Councils
        </p>
      </HeroBanner>

      <MegaCarousel />

      <section className="l-performance-highlights">
        <Parallax className="background" y={[-30, 30]}>
          <div className="bg1" />
        </Parallax>

        <div className="container">
          <h2 className="section-title">2020/21 Performance Highlights</h2>

          <Masonry className="grid" columnClassName="grid-column">
            {performanceHighlights.map((highlight, i) => (
              <InfoCard key={i} title={highlight.title} content={highlight.content} />
            ))}
          </Masonry>
        </div>
      </section>

      <section className="l-achievements">
        <Parallax className="background" y={[-30, 30]}>
          <div className="bg1" />
          <div className="bg2" />
        </Parallax>

        <div className="container">
          <h2 className="section-title">Councils' Strategy 2020/21 Achievements</h2>
          <div className="grid">
            {achievementCards.map((achievementCard, i) => (
              <AchievementCard
                key={i}
                id={i}
                title={achievementCard.title}
                subtitle={achievementCard.subtitle}
                achievements={achievementCard.achievements}
              />
            ))}

            <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
              <StaticImage
                layout="fullWidth"
                objectFit
                style={{
                  height: '100%',
                }}
                className={"static-image"}
                src="./assets/achievements.png"
                alt="Professional Standards Councils’ Strategy 2021"
                quality={100} />
            </div>
          </div>
        </div>
      </section>

      <CTABanner annualReportPage={5} />
    </Layout>
  );
};

export default HomePage;
